module.exports = __webpack_public_path__ + "img/logo.bb53b80d.svg";